import jsonata from 'jsonata';

export default function (data, query) {
	const expression = jsonata(query);

	return expression.evaluate(data);
}
